import React from "react";
import ServiceCard from "../common/Cards/ServiceCard";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="home">
      {/* HEADER/BANNER ROOM SECTION */}
      <section>
        <header className="header-banner">
          <div className="overlay"></div>
          <img
            src="/assets/images/hotel1.jpg"
            alt="Alexestel Hotels"
            className="header-image"
          />

          <div className="animated-texts-overlay-content">
            <h1>
              Welcome to{" "}
              <span className="alexestel-color"> Alexestel Hotels</span>
            </h1>
            <br />
            <h3>
              The Unforgatable Ultimate Fresh Taste Of Hospitality In Burundi
            </h3>
          </div>
        </header>
      </section>

      {/* SEARCH/FIND AVAILABLE ROOM SECTION */}
      <div className="book-now-container">
        <button className="book-now-btn" onClick={() => navigate("/hotels")}>
          Book Now
        </button>
      </div>

      <h2 className="home-services">
        Services at <span className="alexestel-color">Alexestel Hotels</span>{" "}
      </h2>

      {/* SERVICES SECTION */}
      <section className="service-section">
        <ServiceCard
          image={"/assets/images/accommodation.png"}
          title={"Accommodation"}
          description={
            "We have cool and comfortable place to spend as you rejuvinate your energy"
          }
        />
        <ServiceCard
          image={"/assets/images/air-conditioner.png"}
          title={"Air Conditioning"}
          description={"Enjoy the cool breeze in all our rooms"}
        />
        <ServiceCard
          image={"/assets/images/bar.png"}
          title={"Bar and Restaurant"}
          description={
            "We got the most healthy aand delicious food to enjoy over the drink of your choice"
          }
        />
        <ServiceCard
          image={"/assets/images/parking.png"}
          title={"Parking"}
          description={"Ample and secure parking available"}
        />
        <ServiceCard
          image={"/assets/images/wifi-signal.png"}
          title={"Wi-FI"}
          description={
            "Stay connected everywhere within the hotel throughout your stay"
          }
        />
        <ServiceCard
          image={"/assets/images/swimming-pool.png"}
          title={"Swimming Pool"}
          description={
            "Enjoy swimming in our state of the art swimming pool, with clean, regularly refreshed water"
          }
        />
        <ServiceCard
          image={"/assets/images/airport-shuttle.png"}
          title={"Taxi Services"}
          description={
            "Enjoy fast, convenient and comfortable rides within Bujumbura and its environs with taxi services"
          }
        />
        <ServiceCard
          image={"/assets/images/roomservice.png"}
          title={"Room Service"}
          description={
            "Room service crafted for comfort. From fresh breakfasts at sunrise to late night cravings, enjoy delicious meals and attentive service delivered straight to your room, turning every stay into a cozy retreat"
          }
        />
        <ServiceCard
          image={"/assets/images/security.png"}
          title={"24 Hour Security"}
          description={
            "Enjoy peace of mind with our 24-hour security service, ensuring a safe, comfortable, and worry-free stay at any hour of the day or night"
          }
        />
      </section>
    </div>
  );
};
export default HomePage;
